import React, { useState } from "react";
import { motion } from "framer-motion";
import { Waypoint } from "react-waypoint";
import { Mail, Sparkles } from "lucide-react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import "./Reception.css";
const Img1 = "https://images.unsplash.com/photo-1552566626-52f8b828add9?w=600&h=700&fit=crop";

const Reception = () => {
  const [isWayPoint, setIsWaypoint] = useState(false);

  const handleWayPoint = () => {
    setIsWaypoint(true);
  };

  var start = 0,
    end = 100,
    duree = 1,
    delta = Math.ceil((duree * 1000) / end);

  function count() {
    var node = document.getElementsByClassName("reception-number")[0];
    if (isWayPoint) {
      node.innerHTML = ++start;
      if (start < end) {
        setTimeout(count, delta);
      }
    }
  }

  const socialLinks = [
    {
      icon: FaFacebook,
      href: "https://www.facebook.com/Terces1555",
      label: "Like Us",
      color: "#1877F2"
    },
    {
      icon: FaInstagram,
      href: "https://www.instagram.com/terces_solutions/",
      label: "Follow Us",
      color: "#E4405F"
    },
    {
      icon: FaLinkedin,
      href: "https://www.linkedin.com/company/105919678/",
      label: "Connect",
      color: "#0A66C2"
    },
  ];

  return (
    <div className="reception">
      {/* LEFT SIDE - Keep Original CSS Structure */}
      <div className="overlay-image">
        <img src={Img1} alt="restaurant consulting" className="img-reception" style={{ borderRadius: '16px', objectFit: 'cover' }} />

        {/* Floating Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          style={{
            position: 'absolute',
            bottom: '24px',
            left: '24px',
            background: 'white',
            borderRadius: '14px',
            padding: '14px 20px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            zIndex: 3,
            minWidth: '220px',
          }}
        >
          <div style={{
            width: '44px', height: '44px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #1b7840, #155c32)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <Sparkles size={20} color="white" />
          </div>
          <div>
            <div style={{ fontSize: '15px', fontWeight: '700', color: '#111', lineHeight: 1.2 }}>
              Results-Driven Approach
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '3px' }}>
              Built for restaurant growth
            </div>
          </div>
        </motion.div>

        <Waypoint
          onEnter={() => {
            handleWayPoint();
            count();
          }}
        />
      </div>

      {/* RIGHT SIDE - Modernized with Framer Motion */}
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className="side-text"
      >
        {/* Tag */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-6"
        >
          <span className="text-xs md:text-sm font-bold text-primary uppercase tracking-wider">
            Our Mission
          </span>
        </motion.div>

        {/* Main Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-gray-900 leading-[1.1] mb-8"
          style={{ letterSpacing: '-0.02em' }}
        >
          <span className="relative inline-block">
            <span className="relative z-10">To Bring You</span>
            <svg
              className="absolute -bottom-2 left-0 w-full h-3"
              viewBox="0 0 200 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
            >
              <motion.path
                d="M2 8C50 2, 150 2, 198 8"
                stroke="#1b7840"
                strokeWidth="4"
                strokeLinecap="round"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 1, delay: 0.6 }}
              />
            </svg>
          </span>{" "}
          <br />
          <span className="text-primary">Success</span>
        </motion.h1>

        {/* Description */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-base md:text-lg text-gray-600 leading-relaxed pb-4"
        >
          Welcome to Terces's world of innovations. If you're dissatisfied with
          your company's profits or you have plans to grow it, move toward
          Terces because it's a great place to seek help from our team. Our team
          consists of marketing experts with brilliant business acumen.
        </motion.div>

        {/* Decorative Line */}
        <span className="trait"></span>

        {/* Contact & Social Footer */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="text-footer"
        >
          {/* Email Section */}
          <motion.a
            href="mailto:info@terces.io"
            whileHover={{ x: 5 }}
            className="side-mail group"
          >
            <div className="flex items-center gap-3 p-3 bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-primary/20">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary transition-all duration-300">
                <Mail className="w-5 h-5 text-primary group-hover:text-white transition-colors" strokeWidth={2} />
              </div>
              <div className="flex-1">
                <div className="text-[10px] text-gray-500 font-semibold uppercase tracking-wider mb-0.5">
                  Email Us
                </div>
                <div className="text-sm font-semibold text-gray-900 group-hover:text-primary transition-colors">
                  info@terces.io
                </div>
              </div>
            </div>
          </motion.a>

          {/* Social Icons */}
          <div className="flex items-center gap-2">
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <motion.a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: 0.6 + index * 0.1 }}
                  whileHover={{ scale: 1.15, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  className="relative w-10 h-10 bg-white rounded-xl shadow-md flex items-center justify-center hover:shadow-lg transition-all duration-300 group overflow-hidden"
                >
                  {/* Hover background with brand color */}
                  <motion.div
                    className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ backgroundColor: social.color }}
                  />
                  <Icon
                    className="w-[18px] h-[18px] text-gray-700 group-hover:text-white transition-colors relative z-10"
                  />
                </motion.a>
              );
            })}
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Reception;